import styled, { css } from 'styled-components';

import { ReactComponent as TrashIconBase } from 'assets/icons/primary-trash.svg';

import { TrashIconStylesProps } from './DeleteSequence.types';

export const TrashIcon = styled(TrashIconBase)<TrashIconStylesProps>(
  ({ disabled, theme: { palette } }) => css`
    opacity: ${disabled ? 0.5 : 1};

    path {
      fill: ${disabled ? palette.grey[600] : '#2D6CE6'};
    }
  `,
);
